import { render, staticRenderFns } from "./LikeButtonParts.vue?vue&type=template&id=d8d5c0be&scoped=true"
import script from "./LikeButtonParts.vue?vue&type=script&lang=ts"
export * from "./LikeButtonParts.vue?vue&type=script&lang=ts"
import style0 from "./LikeButtonParts.vue?vue&type=style&index=0&id=d8d5c0be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8d5c0be",
  null
  
)

export default component.exports